import Auth from "@aws-amplify/auth";
import Storage from "@aws-amplify/storage";
import * as React from "react";
import config from "../config";
import "../semantic/dist/semantic.min.css";
import "../i18n";
import AuthenticatedRoute from "../components/routes/AuthenticatedRoute"
import UnauthenticatedRoute from "../components/routes/UnauthenticatedRoute"
import SEO from "../components/seo"
import { Router } from "@reach/router"
import NotFound from "./404";
import Home from "../containers/Home";
import Login from "../containers/Login";
import Signup from "../containers/Signup";
import ForgotPassword from "../containers/ForgotPassword";
import VerificationCode from "../containers/VerificationCode";
import Book from "../containers/Book";

Auth.configure({
  Auth: {
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID
  }
})

Storage.configure({
  Storage: {
    region: config.s3.REGION,
    identityPoolId: config.cognito.IDENTITY_POOL_ID
  }
})

const Index = () => (
  <>
    <SEO />
      <Router>
        <Home path="/"/>
        <UnauthenticatedRoute path="/login" component={Login} />
        <UnauthenticatedRoute path="/signup" component={Signup} />
        <UnauthenticatedRoute path="/login/forgotpassword" component={ForgotPassword} />
        <UnauthenticatedRoute path="/signup/forgotcode" component={VerificationCode} />
        <AuthenticatedRoute path="/:bookId" component={Book} />
        <NotFound default />
      </Router>
    </>

)
export default Index;
